import { useMemo } from 'react';
import { useParams } from 'react-router';
import { find, mapValues } from 'lodash';
import { useDrawerStack } from 'hooks/queryParams/useDrawerStack';
import { FORM_ENTITY_IDS_PARAM_NAME } from 'modules/campaigns/config/routes';
import { useFormDataContext } from 'modules/taboola-common-frontend-modules/formData/FormDataContext';
import { matchPathWithoutQuery } from '../../query-params';
import { getParams } from '../utils/getParams';
import { useMultiLayerDrawerEnabled } from './useMultiLayerDrawerEnabled';

const COMMA_SEPARATED_PARAMS = new Set([FORM_ENTITY_IDS_PARAM_NAME]);
const LIST_SEPARATOR = ',';

const emptyObject = {};

const processParamsValues = params =>
    mapValues(params, (value, key) => (COMMA_SEPARATED_PARAMS.has(key) ? value?.split(LIST_SEPARATOR) : value));

export const useMultiLayerPathParams = (customPath, customPattern) => {
    const { pattern: formPattern } = useFormDataContext();
    const { stack } = useDrawerStack();
    const pattern = customPattern || formPattern;

    const isMultiLayerDrawerEnabled = useMultiLayerDrawerEnabled();
    const params = useParams();

    const customizedParams = useMemo(() => {
        const path = find(stack, ({ path }) => !!matchPathWithoutQuery(path, { path: pattern, exact: false }))?.path;

        if (!isMultiLayerDrawerEnabled || !path) {
            return processParamsValues(params) || emptyObject;
        }

        const patternParams = getParams(path, pattern);
        return processParamsValues(patternParams);
    }, [params, pattern, isMultiLayerDrawerEnabled, stack]);

    return customizedParams;
};
